import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import config from "../config";
import { message } from "antd";
import { getCached, setCached } from './cacheStore';
class RawDataReportStore {
  rawDataReport = []
  total = 0
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      rawDataReport: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportExcel: action,
      exportcsv: action,
      exportpdf: action,
      exportxml: action

    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, vehicleId, fromDate, toDate }) {
    const cacheKey = `rawdatareportlist:${companyId}:${vehicleId}:${fromDate}:${toDate}:${offset}:${limit}`;
    const cached = getCached(cacheKey);

    if (cached) {
      this.total = cached.total;
      this.rawDataReport = cached.reportData;
      return;
    }
    var response
    this.loading = true;

    var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": 1 }

    if (config.pythonReport == 1) {
      response = await postApi.getClient('report').post("/miscellaneous_report/raw-data", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=rawdatareport", "postData=" + base64Input);
    }

    const reportData = response?.data?.data?.rawdata ?? []
    const total = parseInt(response?.data?.data?.TotalCount);
    setCached(cacheKey, { total, reportData });

    this.total = total
    this.rawDataReport = reportData;
    this.loading = false;

    // this.rawDataReport = response?.data?.data?.rawdata
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // this.loading = false;

  }


  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport == 1) {



      try {
        var response = await postApi.getClient("report").post("/miscellaneous_report/raw-data/download/excel", getData, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Raw Data Report.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        message.error("Failed to download the report. Please try again.")
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportrawexcel&cid=" +
        getData.companyId +
        "&vid=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {

    if (config.pythonReport == 1) {


      try {
        var response = await postApi.getClient("report").post("/miscellaneous_report/raw-data/download/pdf", getData, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Raw Data Report.pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        message.error("Failed to download the report. Please try again.")
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportrawpdf&cid=" +
        getData.companyId +
        "&vid=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportrawcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportrawxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }





}

export default RawDataReportStore;
